import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { Column, Row, Section } from "@react-email/components";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { useTopBlockStyles } from "../../../Design/useTopBlockStyles";
import { SectionContainer } from "../../../Utils/SectionContainer";
import { FeatureList } from "./FeatureList";
import { defaultStyles } from "./defaultStyles";

export interface FeatureBlock4Props extends ComponentPropsWithRef<"table"> {
  featureListContentDescription1?: ReactNode;
  featureListContentDescription2?: ReactNode;
  featureListContentDescription3?: ReactNode;
  featureListContentImage1?: ReactNode;
  featureListContentImage2?: ReactNode;
  featureListContentImage3?: ReactNode;
  headerContent?: ReactNode;
  imageSectionContent?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const FeatureBlock4 = forwardRef<HTMLTableElement, FeatureBlock4Props>(
  (
    {
      headerContent,
      featureListContentDescription1,
      featureListContentDescription2,
      featureListContentDescription3,
      featureListContentImage1,
      featureListContentImage2,
      featureListContentImage3,
      imageSectionContent,
      styles,
      ...rest
    },
    ref,
  ) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles,
      },
    );

    return (
      <SectionContainer cssProperties={marginStyles}>
        <Section
          ref={ref}
          style={{
            ...backgroundStyles,
            ...paddingStyles,
          }}
          {...rest}
        >
          <Row>
            <Column>{headerContent}</Column>
          </Row>
          <Row>
            <Column>
              <Row style={{ paddingBottom: 28 }}>
                <Column>
                  <FeatureList
                    description={featureListContentDescription1}
                    image={featureListContentImage1}
                  />
                  <FeatureList
                    description={featureListContentDescription2}
                    image={featureListContentImage2}
                  />
                  <FeatureList
                    description={featureListContentDescription3}
                    image={featureListContentImage3}
                  />
                </Column>
              </Row>
              <Row>
                <Column>{imageSectionContent}</Column>
              </Row>
            </Column>
          </Row>
        </Section>
      </SectionContainer>
    );
  },
);

FeatureBlock4.displayName = "FeatureBlock4";
